import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './charge.list-view.html',
    styleUrls: ['./charge.list-view.scss']
})
export class ChargeListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
